var React = require('react');

function ChevronBottom16 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.99994 9.9394L11.4696 6.46973L12.5303 7.53039L8.53027 11.5304C8.38962 11.671 8.19886 11.7501 7.99994 11.7501C7.80103 11.7501 7.61027 11.671 7.46961 11.5304L3.46961 7.53039L4.53027 6.46973L7.99994 9.9394Z"}));
}

ChevronBottom16.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ChevronBottom16;

ChevronBottom16.default = ChevronBottom16;
